/* Brown Bee PDP — assets/pdp-brownbee.js */
(function () {
  function initPdp(root) {
    if (!root || root.dataset.bbInit === '1') return;
    root.dataset.bbInit = '1';

    // ── Gallery (lee del DOM: thumbs con data-full/data-alt) ──
    (function gallery() {
      const hero = root.querySelector('[data-bb-hero]');
      const thumbs = root.querySelector('[data-bb-thumbs]');
      const dots = root.querySelector('[data-bb-dots]');
      if (!hero || !thumbs) return;
      const btns = Array.from(thumbs.querySelectorAll('button'));
      if (!btns.length) return;
      let current = 0;
      if (dots) dots.innerHTML = btns.map(function (_, i) {
        return '<span' + (i === 0 ? ' data-active' : '') + '></span>';
      }).join('');
      const dotEls = dots ? Array.from(dots.children) : [];
      function select(i) {
        current = (i + btns.length) % btns.length;
        const b = btns[current];
        hero.src = b.getAttribute('data-full');
        hero.alt = b.getAttribute('data-alt') || '';
        btns.forEach(function (x, xi) { x.setAttribute('aria-current', xi === current); });
        dotEls.forEach(function (d, di) {
          if (di === current) d.setAttribute('data-active', ''); else d.removeAttribute('data-active');
        });
      }
      btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
      const prev = root.querySelector('[data-bb-prev]');
      const next = root.querySelector('[data-bb-next]');
      if (prev) prev.addEventListener('click', function () { select(current - 1); });
      if (next) next.addEventListener('click', function () { select(current + 1); });
    })();

    // ── "Read more" abre el acordeón "why you'll love it" ──
    (function readMore() {
      const btn = root.querySelector('[data-bb-readmore]');
      const why = root.querySelector('[data-bb-why]');
      if (!btn || !why) return;
      btn.addEventListener('click', function () {
        why.open = true;
        btn.setAttribute('aria-expanded', 'true');
        why.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    })();

    // ── Packs → setea el quantity input de Dawn ──
    (function packs() {
      const qty = root.querySelector('.quantity__input, input[name="quantity"]');
      root.querySelectorAll('[data-bb-pack]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (qty && radio.checked && radio.value) {
            qty.value = radio.value;
            qty.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    })();

    // ── Sticky ATC ──
    (function stickyCta() {
      const anchor = root.querySelector('[data-bb-atc-anchor]');
      const bar = root.querySelector('[data-bb-atc-sticky]');
      if (!anchor || !bar || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(function (entries) {
        const e = entries[0];
        // Mostrar solo cuando el ATC quedó ARRIBA del viewport (se scrolleó más allá),
        // no cuando todavía está por debajo del fold (caso mobile: galería alta arriba).
        const scrolledPast = e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !e.isIntersecting && scrolledPast);
      }, { threshold: 0 });
      io.observe(anchor);
      // el botón de la barra sticky dispara el submit del form real
      const btn = bar.querySelector('[data-bb-sticky-submit]');
      const form = root.querySelector('form[data-type="add-to-cart-form"]');
      if (btn && form) btn.addEventListener('click', function () {
        const real = form.querySelector('[type="submit"]');
        if (real) real.click();
      });
    })();

    // ── Subscription (selling plans) → setea name="selling_plan" en el form ──
    (function subscription() {
      const block = root.querySelector('[data-subs-block]');
      const hidden = root.querySelector('[data-selling-plan-input]');
      if (!block || !hidden) return;
      const freq = block.querySelector('[data-sub-freq]');
      const save = block.querySelector('[data-sub-save]');
      const priceNode = root.querySelector('.bb-price .price-item--regular')
        || root.querySelector('.bb-price .price-item')
        || root.querySelector('.bb-price');
      const original = priceNode ? priceNode.textContent.trim() : null;
      function money(c) { return '$' + (parseInt(c, 10) / 100).toFixed(2); }
      function apply() {
        const sub = block.querySelector('[data-purchase="subscribe"]');
        const on = !!(sub && sub.checked);
        if (freq) freq.disabled = !on;
        // La linea "con codigo" se calcula sobre el precio de compra unica:
        // en modo suscripcion se oculta via CSS para no prometer dos precios.
        root.dataset.bbPurchase = on ? 'subscribe' : 'onetime';
        if (on && freq) {
          const opt = freq.options[freq.selectedIndex];
          hidden.value = freq.value;
          if (opt) {
            if (save && opt.dataset.price && opt.dataset.compare) {
              const pct = Math.round((1 - parseFloat(opt.dataset.price) / parseFloat(opt.dataset.compare)) * 100);
              save.textContent = pct > 0 ? pct + '% off' : '';
            }
            if (priceNode && opt.dataset.price) priceNode.textContent = money(opt.dataset.price);
          }
        } else {
          hidden.value = '';
          if (priceNode && original !== null) priceNode.textContent = original;
        }
      }
      block.querySelectorAll('[data-purchase]').forEach(function (r) { r.addEventListener('change', apply); });
      if (freq) freq.addEventListener('change', apply);
      apply();
    })();
  }

  function boot() { document.querySelectorAll('[data-bb-pdp]').forEach(initPdp); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) {
    const el = e.target.querySelector('[data-bb-pdp]') || (e.target.matches && e.target.matches('[data-bb-pdp]') ? e.target : null);
    if (el) { el.dataset.bbInit = ''; initPdp(el); }
  });
})();
